export enum LayoutType {
	WebPage = "web-page",
	Sidebar = "sidebar",
	Popover = "popover",
}
